import styled from 'styled-components';

import { motion } from 'framer-motion';

interface StyledSubRollingOfferCardProps {
  isHorizontalViewEnabled: boolean;
}

export const StyledSubProductsContainer = styled.div<StyledSubRollingOfferCardProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2px;
  width: 100%;
  height: ${({ isHorizontalViewEnabled }) =>
    isHorizontalViewEnabled ? 178 : 110}px;
  padding: 2px 4px;
`;

export const StyledMainProduct = styled(
  motion.div,
)<StyledSubRollingOfferCardProps>`
  height: ${({ isHorizontalViewEnabled }) =>
    isHorizontalViewEnabled ? 178 : 110}px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ isHorizontalViewEnabled }) =>
    isHorizontalViewEnabled ? 'center' : 'end'};
  flex-direction: column;
  gap: 2px;
  padding: 4px;
  box-sizing: border-box;

  .main-product-image {
    width: ${({ isHorizontalViewEnabled }) =>
      isHorizontalViewEnabled ? 72 : 64}px;
    text-align: center;
    height: ${({ isHorizontalViewEnabled }) =>
      isHorizontalViewEnabled ? 72 : 64}px;
    z-index: 100;
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .product-image-container {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .text {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center !important;
    position: relative;
    z-index: 1;
    padding-top: 0;

    .quantity {
      margin: 0;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      color: ${({ color }) => color};
      position: relative;
      direction: ltr;
      text-shadow: black 0px 0px 2px;

      &:after {
        background: none;
        content: '${({ title }) => CSS.escape(title || '')}';
        left: 0;
        top: 0;
        z-index: -1;
        position: absolute;
        direction: ltr;
      }
    }
    .stroked {
      font-weight: 600;
      color: white;
      position: relative;
      margin: 0;
      text-shadow: black 0px 0px 2px;

      &::after {
        content: ' ';
        height: 2px;
        width: 100%;
        background: #d8232a;
        position: absolute;
        left: 0;
        top: 50%;
      }
    }
  }
`;

export const StyledSubProduct = styled(
  motion.div,
)<StyledSubRollingOfferCardProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 calc(50% - 2px);
  max-width: calc(50% - 2px);
  align-items: center;
  gap: 2px;
  justify-content: center;

  .product-image-container {
    .product {
      position: relative;
      z-index: 2;
    }
  }

  .sub-product-image {
    width: ${({ isHorizontalViewEnabled }) =>
      isHorizontalViewEnabled ? 48 : 32}px;
    height: ${({ isHorizontalViewEnabled }) =>
      isHorizontalViewEnabled ? 48 : 32}px;
    z-index: 100;
    display: flex;
    justify-content: center;
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .text {
    max-width: calc(100% - 10px);
    padding: 0;
    flex-direction: column;
    gap: 4px;

    p {
      font-size: 14px;
      font-weight: 600;
      color: ${(props) => props.color};
      margin: 0;
      text-shadow: black 0px 0px 2px;
      line-height: ${({ isHorizontalViewEnabled }) =>
        isHorizontalViewEnabled ? 16 : 14}px;
    }
  }
`;

export const StyledSubRollingOfferPriceButton = styled.div<StyledSubRollingOfferCardProps>`
  height: 42px;
  width: 100%;
  background: var(--button-bg-color);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 0 7px 7px;
  font-weight: 700;
  font-size: ${({ isHorizontalViewEnabled }) =>
    isHorizontalViewEnabled ? 20 : 16}px;
  color: var(--button-text-color);
  position: relative;
  direction: ltr;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  border-bottom: 4px solid rgba(56, 127, 34, 1);
  box-shadow: 0px -2px 4px -2px rgba(255, 255, 255, 0.8) inset;

  .lockImage {
    position: absolute;
    left: 10px;
    transform-origin: center;
  }
`;

export const StyledSubRollingOfferPrice = styled.div<any>`
  display: flex;
  direction: ltr;
  justify-content: center;
  width: 100%;
  color: var(--button-text-color);
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.5);

  .totalPrice {
    display: flex;
    align-items: center;
    line-height: 1;
  }
`;
